import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/changePassword.svg";

const ChangePasswordIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default ChangePasswordIcon;
